import React from "react";
import useFilter from "Utils/useFilter";
import DateRangePicker from "Components/dateRangePicker/DateRangePicker";
import XDate from "xdate";
import { Icon, search, close } from "Icons/index";
import cx from "classnames";
import { parse, isValid } from "date-fns";

const DateRangeFilter = ({
  label,
  className,
  isActive,
  format = "yyyy-MM-dd",
  onChange,
  startDate,
  endDate,
  disabled,
}) => {
  let start = parse(startDate, "yyyy-MM-dd", new Date());
  let end = parse(endDate, "yyyy-MM-dd", new Date());

  return (
    <div className="relative w-full">
      <DateRangePicker
        label={label}
        disabled={disabled}
        isActive={isActive}
        className={className}
        startDate={!isValid(start) ? null : start}
        endDate={!isValid(end) || !isValid(start) ? null : end}
        openToDate={new Date()}
        onChange={([startDate, endDate]) => {
          if (onChange) {
            onChange([new XDate(startDate).toString(format), endDate && new XDate(endDate).toString(format)]);
          }
        }}
        // onStartDateChange={(value) => filterStartDate(new XDate(value).toString("yyyy-MM-dd"))}
        // onEndDateChange={(value) => filterEndDate(value && new XDate(value).toString("yyyy-MM-dd"))}
      />

      <div className="flex justify-center items-center rounded absolute right-1 bottom-1 p-[0.3rem] cursor-pointer hover:bg-[--accent-l35]">
        {(startDate || endDate) && (
          <Icon
            svg={close}
            width="0.875rem"
            height="0.875rem"
            onClick={() => onChange([null, null])}
            className={cx("flex flex-col justify-center items-center svg-accent", {
              ["opacity-50 pointer-events-none"]: false,
            })}
          />
        )}
      </div>
    </div>
  );
};

export default DateRangeFilter;
